import { Address } from 'viem'
import { useAccount as useAccountWagmi } from 'wagmi'

export function useAccount(): Address | undefined {
  return useAccountWagmi().address
}
